import { render, staticRenderFns } from "./DataCorrectionRequest.vue?vue&type=template&id=bc6c2a02&scoped=true&"
import script from "./DataCorrectionRequest.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c2a02",
  null
  
)

export default component.exports